import { Chip } from '@mui/material';
import { formatters } from '@utils/formattersV2';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

const NO_CHANGE = 'No Change';

const chipSchemes = {
  positive: {
    color: unifiedPlatformColorPalette.lightPrimary,
    backgroundColor: unifiedPlatformColorPalette.lightSuccess50,
    startAdornment: '↑',
  },

  negative: {
    color: unifiedPlatformColorPalette.lightErrorDark,
    backgroundColor: unifiedPlatformColorPalette.lightErrorLight,
    startAdornment: '↓',
  },

  neutral: {
    color: unifiedPlatformColorPalette.lightTextPrimary,
    backgroundColor: unifiedPlatformColorPalette.gray100,
    startAdornment: '',
  },
};

const getChipScheme = (difference: number) => {
  if (difference > 0) {
    return chipSchemes.positive;
  } else if (difference < 0) {
    return chipSchemes.negative;
  } else {
    return chipSchemes.neutral;
  }
};

export type DifferenceChipProps = {
  difference: number;
  formatter?: (value: number | null | undefined) => string;
};

export const DifferenceChip = (props: DifferenceChipProps) => {
  const differenceChipScheme = getChipScheme(props.difference);
  const absoluteDifference = Math.abs(props.difference);
  const label =
    absoluteDifference === 0
      ? NO_CHANGE
      : [
          differenceChipScheme.startAdornment,
          props.formatter
            ? props.formatter(absoluteDifference)
            : formatters.number(absoluteDifference),
        ].join(' ');

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: differenceChipScheme.backgroundColor,
        color: differenceChipScheme.color,
      }}
    />
  );
};
